import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Får jag göra kunskapsprovet på engelska?";
const SHORT_ANSWER = "Ja. Folkhälsomyndighetens provsystem stödjer engelska. Tala om språkönskemålet vid bokning hos kommunen.";

export const Route = createFileRoute("/fraga/far-jag-gora-provet-pa-engelska")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Får jag göra kunskapsprovet på engelska" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Provet finns även på arabiska, persiska/farsi, somaliska, turkiska, kurdiska och thailändska i många kommuner. Lokala variationer förekommer – fråga din tillståndsenhet."}
      source={{ label: "Folkhälsomyndigheten – Kunskapsprov", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/kunskapsprov/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsprov-alkohollagen", label: "Kunskapsprovet – upplägg och språk" }}
      related={[{"to": "/fraga/far-jag-tolk-pa-provet", "label": "Får jag använda tolk på kunskapsprovet?"}, {"to": "/fraga/behover-alla-i-ledningen-gora-provet", "label": "Behöver alla i ledningen göra kunskapsprovet?"}, {"to": "/fraga/var-bokar-jag-provet", "label": "Var bokar jag kunskapsprovet?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Får jag göra kunskapsprovet på engelska?" },
      { name: "description", content: "Ja. Folkhälsomyndighetens provsystem stödjer engelska. Tala om språkönskemålet vid bokning hos kommunen." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/far-jag-gora-provet-pa-engelska" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/far-jag-gora-provet-pa-engelska" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/far-jag-gora-provet-pa-engelska",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Får jag göra kunskapsprovet på engelska", url: "https://alkoholprovet.se/fraga/far-jag-gora-provet-pa-engelska" },
      ]),
    ],
  }),
});
